module.exports = __webpack_public_path__ + "static/media/infoiscorrect.8387210f.mp3";